module.exports = __webpack_public_path__ + "static/media/ARI-STEVI Smart 423-463.fb3e57c1.jpg";